<div class="page-posting-overlay-container">

    <div class="page-posting-overlay">

    </div>

    <div class="page-posting-loader">

    </div>
</div>